<template>
  <div
    class="orm-offerSlider orm-offerSlider--offers"
    :style="{ height: sliderHeight + 'px' }"
    :class="[{ animate: !animate }, { init: init }]"
    id="offersSlide"
  >
    <transition-group name="fade" tag="div" class="orm-offerSlider__inner">
      <div
        v-for="(item, index) in items + 1"
        :key="item"
        class="orm-offerSlider__slideWrapper--offers"
        :class="[
          { show: getShowState(index) },
          { prev: getPrevState(index) },
          {
            hover: getHoverState(index),
          },
          {
            preHover: getPreHoverState(index),
          },
          {
            next: getNextState(index),
          },
        ]"
        :data-ref="images.length - 1 + ' / ' + currentIndex"
      >
        <div
          class="orm-offerSlider__slide orm-offerSlider__slide--offers orm-offerSlider__slide--hide"
          :class="[
            { show: currentIndex == index },
            {
              next: getNextState(index),
            },
          ]"
          :style="[
            {
              backgroundImage: getURI(item - 1),
            },
            { paddingTop: calcRatio(ratio) + '%' },
          ]"
        >
          <div class="orm-offerSlider__content">
            <div
              class="orm-offerSlider__content_headline orm-mb-32"
              v-html="images[item - 1].headline"
            ></div>
            <strong
              class="orm-offerSlider__content_subheadline subheadline"
              v-html="images[item - 1].description"
            ></strong>
            <div
              class="orm-offerSlider__content_copy orm-mb-32 description"
              v-html="images[item - 1].description2"
            ></div>
            <div class="orm-row bottom-xs orm-mb-32">
              <div
                class="orm-col-xs-12 orm-col-sm-12 orm-col-md-12 orm-mb-16 orm-mb-sm-0 text-center"
              >
                <div class="orm-offerSlider__content_pricetext">
                  {{ images[item - 1].price_text || "pro Tag ab" }}
                  <span
                    class="orm-offerSlider__content_price"
                    v-html="
                      convertCurrency(
                        showNettoPrice
                          ? images[item - 1].net_price
                          : images[item - 1].price
                      )
                    "
                  ></span>
                </div>
              </div>
            </div>
            <div class="orm-row bottom-xs">
              <div
                class="orm-col-xs-12 orm-col-sm-12 orm-col-md-12 text-center"
              >
                <button
                  @click="select(images[item - 1])"
                  class="orm-offerSlider__button orm-button__cta orm-button__cta--offer wide"
                >
                  {{ i18n("cargroup/select_offer") || "Angebot sichern"
                  }}<i class="orm-button__cta--offer-icon far fa-stars"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="orm-offerSlider__content_legaltext"
          v-if="images[item - 1].description3"
          v-html="images[item - 1].description3"
        ></div>
      </div>
    </transition-group>
    <!-- <div class="orm-offerSlider__controll" v-if="images.length > 1 && controlls"
      :class="{ 'orm-offerSlider__controll--fade': controllsFade }">

      <div v-if="arrows">
        <div class="orm-offerSlider__controll_arrows orm-offerSlider__controll_arrows--left" @click="prev">
          <i class="fa fa-chevron-left"></i>
        </div>
        <div class="orm-offerSlider__controll_arrows orm-offerSlider__controll_arrows--right" @click="next">
          <i class="fa fa-chevron-right"></i>
        </div>
      </div>

    </div> -->
  </div>
  <div
    v-if="controllNext && images.length > 1"
    class="orm-offerSlider__controll_next__wrapper"
    :style="{ height: imageHeight + 'px' }"
  >
    <div class="orm-offerSlider__controll_next" @click="next">
      {{ i18n("offerSlider/next") || "nächstes" }}
      <i class="fa fa-arrow-right"></i>
    </div>
    <div class="orm-offerSlider__controll__dots" v-if="dots">
      <div
        v-for="(i, index) in images"
        :key="i"
        class="orm-offerSlider__controll__dot"
        :class="{
          'orm-offerSlider__controll__dot--active': currentIndex == index,
        }"
        @click="showItem(index)"
      ></div>
    </div>
  </div>
  <div class="backdrop" :style="{ height: imageHeight + 'px' }"></div>
  <Modal
    v-if="showModal && selectedCargroup"
    :car="selectedCargroup"
    :show-category="true"
    :multi-categories="true"
    :disable-carfilter="true"
    :is-offer="true"
    @cancel="cancel()"
  />
</template>
<script>
import store from "@/store";
import { convertCurrency } from "@/constants/formater";
import Modal from "@/components/modals/modal-stationtimeselect.vue";
import i18n from "@/mixins/mixins";
export default {
  name: "OffersSliderComponent",
  components: { Modal },
  mixins: [i18n],
  props: {
    images: Array,
    ratio: {
      type: String,
      required: false,
      default: "4/3",
    },
    controlls: {
      type: Boolean,
      required: false,
      default: true,
    },
    controllsFade: {
      type: Boolean,
      required: false,
      default: true,
    },
    dots: {
      type: Boolean,
      required: false,
      default: true,
    },
    arrows: {
      type: Boolean,
      required: false,
      default: false,
    },
    controllNext: {
      type: Boolean,
      required: false,
      default: false,
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: true,
    },
    intervall: {
      type: Number,
      required: false,
      default: 6000,
    },
    lightbox: {
      type: Boolean,
      required: false,
      default: false,
    },
    sttype: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      timer: null,
      currentIndex: 0,
      items: null,
      initialX: null,
      initialY: null,
      interimItems: null,
      convertCurrency,
      showModal: false,
      animate: false,
      nextHoverState: false,
      showState: false,
      nextState: true,
      preHoverState: false,
      init: true,
      sliderHeight: 0,
      imageHeight: 0,
      showNettoPrice: false,
    };
  },

  async created() {
    const showNetto = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_SHOW_NETTO_PRICE"
    );
    switch (showNetto) {
      case "1":
        this.showNettoPrice = true;
        break;
      default:
        break;
    }
  },

  mounted() {
    const element = document.querySelector("#crentOffersSlider");
    let startItem = element.getAttribute("data-startitem") - 1;

    if (startItem != null) {
      if (startItem > this.images.length - 1 || startItem < 0) {
        startItem = 0;
      }
      this.currentIndex = startItem;
    }

    this.items = this.images.length - 1;
    // console.log("offers: " + this.items);
    if (this.images.length > 1 && this.autoplay) this.startSlide();
    setTimeout(() => {
      this.init = false;
    }, 1500);
    this.$el.nextElementSibling.addEventListener(
      "touchstart",
      this.startTouch,
      {
        passive: true,
      }
    );
    this.$el.nextElementSibling.addEventListener("touchmove", this.moveTouch, {
      passive: true,
    });
    this.$el.nextElementSibling.addEventListener("mousedown", this.startTouch, {
      passive: true,
    });
    this.$el.nextElementSibling.addEventListener("mouseup", this.moveTouch, {
      passive: true,
    });
    this.$el.nextElementSibling.addEventListener(
      "mouseenter",
      () => {
        if (this.images.length > 1 && this.autoplay) clearInterval(this.timer);
      },
      {
        passive: true,
      }
    );
    this.$el.nextElementSibling.addEventListener(
      "mouseleave",
      () => {
        if (this.images.length > 1 && this.autoplay)
          this.timer = setInterval(this.next, this.intervall);
      },
      {
        passive: true,
      }
    );
    this.calcSlideHeight();
    window.addEventListener("resize", () => {
      this.calcSlideHeight();
    });
  },

  unmounted() {
    this.$el.nextElementSibling.removeEventListener(
      "touchmove",
      this.moveTouch,
      {
        passive: true,
      }
    );
    this.$el.nextElementSibling.removeEventListener(
      "touchstart",
      this.startTouch,
      {
        passive: true,
      }
    );
    this.$el.nextElementSibling.removeEventListener(
      "mousedown",
      this.startTouch,
      {
        passive: true,
      }
    );
    this.$el.nextElementSibling.removeEventListener("mouseup", this.moveTouch, {
      passive: true,
    });
    this.$el.nextElementSibling.removeEventListener(
      "mouseenter",
      this.startTouch
    );
    this.$el.nextElementSibling.removeEventListener(
      "mouseleave",
      this.moveTouch
    );
  },

  methods: {
    startSlide() {
      this.timer = setInterval(this.next, this.intervall);
    },
    select(item) {
      store.dispatch("offers/SELECT_OFFER", item);
      this.selectedCargroup = {
        category: item.categories,
        enabled_stations: item.station_ids,
      };
      this.showModal = true;
    },
    cancel() {
      this.selectedCargroup = null;
      this.showModal = false;
    },
    next() {
      if (this.animate) return;
      this.calcSlideHeight(true);
      this.currentIndex += 1;
      if (this.currentIndex > this.items) this.currentIndex = 0;
      document.getElementById("offersSlide").blur();
      this.animate = true;
      this.showState = true;
      this.preHoverState = false;

      document.querySelector(
        ".orm-offerSlider__slideWrapper--offers.prev"
      ).style.opacity = 1;
      setTimeout(() => {
        this.preHoverState = true;
      }, 500);
      setTimeout(() => {
        this.showState = true;
        document.querySelector(
          ".orm-offerSlider__slideWrapper--offers.prev"
        ).style.opacity = 0;
      }, 1600);
      setTimeout(() => {
        this.animate = false;
      }, 1650);
    },
    prev() {
      this.currentIndex -= 1;
      if (this.currentIndex < 0) this.currentIndex = this.items;
    },
    showItem(index) {
      if (this.animate) return;
      this.calcSlideHeight(true);
      // console.log(index);
      this.currentIndex = index;
      if (this.images.length > 1 && this.autoplay) {
        clearInterval(this.timer);
        this.timer = setInterval(this.next, this.intervall);
      }
      document.getElementById("offersSlide").blur();
      this.animate = true;
      this.showState = true;
      this.preHoverState = false;

      document.querySelector(
        ".orm-offerSlider__slideWrapper--offers.prev"
      ).style.opacity = 1;
      setTimeout(() => {
        this.preHoverState = true;
      }, 500);
      setTimeout(() => {
        this.showState = true;
        document.querySelector(
          ".orm-offerSlider__slideWrapper--offers.prev"
        ).style.opacity = 0;
      }, 1600);
      setTimeout(() => {
        this.animate = false;
      }, 1650);
    },
    calcSlideHeight(calcnext) {
      let elementHeight = document
        .querySelector(".orm-offerSlider__slideWrapper--offers.show")
        .getBoundingClientRect().height;
      let imageHeight = document
        .querySelector(".orm-offerSlider__slide--offers.show")
        .getBoundingClientRect().height;
      if (calcnext) {
        elementHeight = document
          .querySelector(".orm-offerSlider__slideWrapper--offers.next")
          .getBoundingClientRect().height;
        imageHeight = document
          .querySelector(".orm-offerSlider__slide--offers.next")
          .getBoundingClientRect().height;
      }
      //console.log(elementHeight);
      this.sliderHeight = elementHeight;
      this.imageHeight = imageHeight;
    },
    calcRatio(ratio) {
      const splitRatio = ratio.split("/");
      const calc = (splitRatio[1] / splitRatio[0]) * 100;
      return calc.toFixed(2);
    },
    getURI(item) {
      // console.log(item);
      if (this.images[item])
        return 'url("' + this.images[item].image_url + '")';
    },
    startTouch(e) {
      if (this.images.length > 1 && this.autoplay) clearInterval(this.timer);
      if (e.type == "mousedown") {
        this.initialX = e.clientX;
        this.initialY = e.clientY;
      } else {
        this.initialX = e.touches[0].clientX;
        this.initialY = e.touches[0].clientY;
      }
    },

    moveTouch(e) {
      // if (this.animate) return;
      if (this.initialX === null) {
        return;
      }

      if (this.initialY === null) {
        return;
      }
      let currentX = 0;
      let currentY = 0;
      if (e.type == "mouseup") {
        currentX = e.clientX;
        currentY = e.clientY;
      } else {
        currentX = e.touches[0].clientX;
        currentY = e.touches[0].clientY;
      }

      const diffX = this.initialX - currentX;
      const diffY = this.initialY - currentY;

      if (Math.abs(diffX) > Math.abs(diffY)) {
        // sliding horizontally
        if (diffX > 0) {
          this.next();
          e.preventDefault();
        } else {
          // this.prev();
          e.preventDefault();
        }
        document.getElementById("offersSlide").blur();
        this.animate = true;
        this.showState = true;
        this.preHoverState = false;
        setTimeout(() => {
          this.preHoverState = true;
        }, 500);
        setTimeout(() => {
          this.showState = true;
        }, 1600);
        setTimeout(() => {
          this.animate = false;
        }, 1600);
      } else {
        // sliding vertically
        if (diffY > 0) {
          // swiped up
          // console.log("swiped up");
        } else {
          // swiped down
          // console.log("swiped down");
        }
      }

      this.initialX = null;
      this.initialY = null;
      if (this.images.length > 1 && this.autoplay) {
        this.timer = setInterval(this.next, this.intervall);
      }
    },
    nextHover(type) {
      if (type === "enter") {
        this.nextHoverState = true;
      } else {
        this.nextHoverState = false;
      }
    },
    getHoverState(index) {
      if (this.preHoverState) {
        if (
          this.currentIndex == index - 1 ||
          (this.images.length - 1 == this.currentIndex && index == 0)
        ) {
          return this.nextHoverState;
        } else {
          return false;
        }
      }
    },
    getPreHoverState(index) {
      if (
        this.currentIndex == index - 1 ||
        (this.images.length - 1 == this.currentIndex && index == 0)
      ) {
        return this.nextHoverState;
      } else {
        return false;
      }
    },
    getNextState(index) {
      if (this.nextState)
        if (
          this.currentIndex == index - 1 ||
          (this.images.length - 1 == this.currentIndex && index == 0)
        ) {
          return true;
        } else {
          return false;
        }
    },
    getShowState(index) {
      if (this.currentIndex == index) {
        return true;
      } else {
        return false;
      }
    },
    getPrevState(index) {
      if (
        this.currentIndex == index + 1 ||
        (this.currentIndex == 0 && index == this.images.length - 1)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  computed: {
    currentImg: function() {
      return this.images[Math.abs(this.currentIndex) % this.images.length];
    },
  },
};
</script>
